import { useState } from "react";
import {
  ADD_SUBSCRIPTION_TO_CART,
  CREATE_CHECKOUT_SESSION_ENDPOINT,
  SUBSCRIPTION_ENDPOINT,
} from "../../_actions/endpoints";
import { useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import TldrPaymentStatusModal from "./Modals/TldrPaymentStatusModal";
import TldrPlanSwitchConfirmationModal from "./Modals/TldrPlanSwitchConfirmationModal";
import { handleHTTPError } from "../../_actions/errorHandlerActions";

import { syncWorkspaces } from "../../_actions/authActions";
import { analyticsTrackEvent } from "../../_utils/common";
import { BILLING_AND_PAYMENT } from "../../_utils/routes";
import { useHistory } from "react-router-dom";

import { PaymentSources } from "../../_actions/types";

import { getSubscription } from "../../_actions/subscriptionActions";

import TldrPaymentSummaryModal from "./Modals/TldrPaymentSummaryModal";
import TldrBillingPlansCardDetails from "./TldrBillingPlansCardDetails";
import ConfirmModal from "../../_components/confirmModal/ConfirmModal";
import { useTranslation } from "react-i18next";
import { subscriptionFeaturesList } from "../../_components/details/constants";

const TldrBillingPlansCard = ({
  plan,
  activeSubscription,
  planIndex,
  yearlyInterval,
  currentOrg,
  adminMember,
  showSummary,
  selectedPlanId,
  setSelectedPlanId,
  notSelectable,
}) => {
  const { t } = useTranslation(["billing"]);
  const dispatch = useDispatch();
  const history = useHistory();
  const subscription = useSelector((state) => state.subscription);
  const socialAccounts = useSelector(
    (state) => state.socialAccountsStore.accounts
  );
  const [updatingPlan, setUpdatinPlan] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState({
    state: false,
    grade: "",
    selectedPlan: null,
    cartData: null,
  });
  const [showPaymentStatusModal, setShowPaymentStatusModal] = useState({
    state: false,
    status: "",
    type: null,
    error: null,
  });

  const [cartData, setCartData] = useState({});
  const [downgradeConfirmation, setDowngradeConfirmation] = useState({
    state: false,
    grade: "",
    selectedPlan: null,
    cartData: null,
  });
  const stripe = useStripe();

  const { subscribedPlan } = subscription;
  const { source } = subscribedPlan;
  const [showPaymentOptionsModal, setShowPaymentOptionsModal] = useState({
    state: false,
    selectedPlan: null,
  });

  function handleSwitchPlan(selectedPlan) {
    const isDowngrading =
      parseInt(subscribedPlan?.plan?.amount) >
      parseInt(selectedPlan?.unit_amount / 100);

    axios
      .post(ADD_SUBSCRIPTION_TO_CART, {
        plan: selectedPlan.id,
      })
      .then((res) => {
        setUpdatinPlan(false);
        if (isDowngrading) {
          setDowngradeConfirmation({
            state: true,
            grade: "downgrade",
            selectedPlan: selectedPlan,
            cartData: res.data,
          });
        } else {
          setShowConfirmationModal({
            state: true,
            grade: "upgrade",
            selectedPlan: selectedPlan,
            cartData: res.data,
          });
        }
      })
      .catch((error) => {
        setUpdatinPlan(false);
        handleHTTPError(error);
        setShowConfirmationModal({
          state: false,
          grade: "",
          selectedPlan: null,
          cartData: null,
        });
      });
  }

  function handleStripeCheckoutForm(selectedPlan) {
    if (
      selectedPlan?.unit_amount > 0 &&
      (!subscribedPlan.customer ||
        !subscribedPlan?.customer?.payment_method?.card)
    ) {
      setUpdatinPlan(true);
      axios
        .post(CREATE_CHECKOUT_SESSION_ENDPOINT, {
          price: selectedPlan.id,
        })
        .then((res) => {
          analyticsTrackEvent("subscribed", {
            plan: selectedPlan.id,
            unit: selectedPlan.unit_amount,
          });
          setUpdatinPlan(false);
          if (res.data?.session_url) {
            window.location.href = res.data.session_url;
            return null;
          } else {
            stripe.redirectToCheckout({ sessionId: res.data.session_id });
          }
        });
    } else {
      setUpdatinPlan(true);
      handleSwitchPlan(selectedPlan);
    }
  }

  function handleCheckoutForm(selectedPlan) {
    if (
      selectedPlan?.unit_amount > 0 &&
      subscribedPlan.source !== PaymentSources.BRAINTREE
    ) {
      setUpdatinPlan(true);
      axios
        .post(ADD_SUBSCRIPTION_TO_CART, {
          plan: selectedPlan.id,
        })
        .then((res) => {
          setUpdatinPlan(false);

          setCartData(res.data);
          setShowPaymentOptionsModal({
            state: true,
            selectedPlan: plan,
          });
        })
        .catch((error) => {
          setUpdatinPlan(false);

          setShowPaymentOptionsModal({
            state: false,
            selectedPlan: null,
          });
          handleHTTPError(error);
        });
    } else {
      setUpdatinPlan(true);
      handleSwitchPlan(selectedPlan);
    }
  }

  function handleSubscriptionChange(newPlan) {
    if (updatingPlan) {
      return;
    }
    setUpdatinPlan(true);
    var subscriptionBody = {
      plan: newPlan.id,
      subscription_id: subscribedPlan.id,
    };

    if (source === PaymentSources.STRIPE) {
      Object.assign(subscribedPlan, {
        subscription_id: subscribedPlan.id,
      });
    }

    setUpdatinPlan(true);
    axios
      .post(SUBSCRIPTION_ENDPOINT, subscriptionBody)
      .then((res) => {
        analyticsTrackEvent("subscribed", {
          plan: newPlan.id,
          unit: newPlan.unit_amount,
        });

        setUpdatinPlan(false);
        const type = showConfirmationModal.grade;
        setShowConfirmationModal({
          state: false,
          grade: "",
          selectedPlan: null,
          cartData: null,
        });

        setShowPaymentStatusModal({
          state: true,
          status: "success",
          type: type,
          error: null,
        });

        dispatch(syncWorkspaces());
        dispatch(getSubscription());
      })
      .catch((error) => {
        setUpdatinPlan(false);
        setShowPaymentStatusModal({
          state: true,
          status: "error",
          type: null,
          error: error.response.data.detail,
        });
      });
  }

  function handleDefaultPayment(selectedPlan) {
    if (selectedPlan?.unit_amount > 0) {
      handleCheckoutForm(selectedPlan);
    } else {
      setUpdatinPlan(true);
      handleSwitchPlan(selectedPlan);
    }
  }

  function handlePaymentBySource(plan) {
    if (parseInt(plan?.unit_amount) === 0 && currentOrg?.members_count > 1) {
      return;
    }
    if (!adminMember?.is_admin && !adminMember?.is_primary) {
      return;
    }

    switch (source) {
      case PaymentSources.SHOPIFY:
      case PaymentSources.STRIPE:
        handleStripeCheckoutForm(plan);
        break;
      case PaymentSources.BRAINTREE:
        handleCheckoutForm(plan);
        break;
      default:
        handleDefaultPayment(plan);
        break;
    }
  }

  function isDowngradable(planIndex, connectedAccounts) {
    const foundPlan = subscriptionFeaturesList.find(
      (plan, i) => i === planIndex
    );
    return connectedAccounts <= foundPlan?.socialAcounts;
  }

  return (
    <>
      <TldrBillingPlansCardDetails
        plan={plan}
        activeSubscription={activeSubscription}
        planIndex={planIndex}
        yearlyInterval={yearlyInterval}
        currentOrg={currentOrg}
        adminMember={adminMember}
        showSummary={showSummary}
        selectedPlanId={selectedPlanId}
        setSelectedPlanId={setSelectedPlanId}
        notSelectable={notSelectable}
        updatingPlan={updatingPlan}
        handlePaymentBySource={handlePaymentBySource}
      />
      {showPaymentStatusModal.state ? (
        <TldrPaymentStatusModal
          show={showPaymentStatusModal.state}
          status={showPaymentStatusModal.status}
          type={showPaymentStatusModal.type}
          error={showPaymentStatusModal.error}
          onHide={() => {
            setShowPaymentStatusModal({
              state: false,
              status: "",
              type: null,
              error: null,
            });
            history.push(BILLING_AND_PAYMENT);
          }}
        />
      ) : null}

      {showConfirmationModal.state ? (
        <TldrPlanSwitchConfirmationModal
          show={showConfirmationModal.state}
          grade={showConfirmationModal.grade}
          newSubscription={showConfirmationModal.selectedPlan}
          cartData={showConfirmationModal.cartData}
          onHide={() =>
            setShowConfirmationModal({
              state: false,
              grade: "",
              selectedPlan: null,
              cartData: null,
            })
          }
          onYes={() => {
            handleSubscriptionChange(showConfirmationModal.selectedPlan);
          }}
          loading={updatingPlan}
        />
      ) : null}

      {downgradeConfirmation.state ? (
        <ConfirmModal
          confirmButtonText={t("confirmation.confirm")}
          cancelButtonText={t("confirmation.cancel")}
          isDisabled={!isDowngradable(planIndex, socialAccounts.length)}
          isOpen={downgradeConfirmation.state}
          title={t("confirmation.title")}
          message={
            !isDowngradable(planIndex, socialAccounts.length)
              ? t("confirmation.downgrade_message")
              : t("confirmation.message")
          }
          onConfirm={() => {
            setShowConfirmationModal({
              state: true,
              grade: downgradeConfirmation.grade,
              selectedPlan: downgradeConfirmation.selectedPlan,
              cartData: downgradeConfirmation.cartData,
            });
            setDowngradeConfirmation({
              state: false,
              grade: "",
              selectedPlan: null,
              cartData: null,
            });
          }}
          onClose={() =>
            setDowngradeConfirmation({
              state: false,
              grade: "",
              selectedPlan: null,
              cartData: null,
            })
          }
        />
      ) : null}

      {showPaymentOptionsModal.state ? (
        <TldrPaymentSummaryModal
          isLoading={updatingPlan}
          handleStripeCheckout={handleStripeCheckoutForm}
          cartItems={cartData}
          onClose={() => {
            setShowPaymentOptionsModal({
              state: false,
              selectedPlan: null,
            });
          }}
          selectedPlan={showPaymentOptionsModal.selectedPlan}
        />
      ) : null}
    </>
  );
};

export default TldrBillingPlansCard;
